import { supabase, PAPERS_TABLE } from "@/lib/supabase";

// term_values = পেপারের ট্যাগ ("class:class-6" ইত্যাদি, GIN index আছে)। পুরনো কলামগুলো সার্ভার-নির্ধারিত
// প্রতিচ্ছবি — fallback হিসেবে রাখা (src/lib/taxonomy.js → tagsOf)।
const CARD_FIELDS =
  "id, slug, title, teacher_name, institution, class_level, subject, exam_type, medium, term_values, copy_count, view_count, created_at";

// PostgREST-এর or(...) ফিল্টারে কমা/বন্ধনী/উদ্ধৃতি আর wildcard মানে বিশেষ — সার্চ লেখা থেকে সেগুলো ফেলে দেওয়া
const cleanSearch = (s) => (s ?? "").replace(/[,()"\\%*]/g, " ").replace(/\s+/g, " ").trim();

function sorted(query, sort) {
  // দ্বিতীয় sort (id) না থাকলে সমান copy/view-এর সারিগুলো পাতা বদলালে এলোমেলো হয়ে এক পেপার দুবার/বাদ যেত
  if (sort === "most-copied") query = query.order("copy_count", { ascending: false });
  else if (sort === "most-viewed") query = query.order("view_count", { ascending: false });
  else query = query.order("created_at", { ascending: false });
  return query.order("id", { ascending: false });
}

// tags: ["class:class-6", "subject:math"] — সবকটা থাকা পেপার (ক্যাটাগরি জুড়ে AND)।
// ফেরত: { rows, total } — total = ফিল্টারে মোট কতগুলো মিলেছে ("আরও দেখান"-এর জন্য)।
export async function fetchPaperPage({ tags = [], search, sort = "newest", limit = 24, offset = 0 } = {}) {
  const q = cleanSearch(search);

  const run = (mode) => {
    let query = supabase.from(PAPERS_TABLE).select(CARD_FIELDS, { count: "exact" }).eq("status", "approved");
    if (tags.length > 0) query = query.contains("term_values", tags);
    if (q) {
      query =
        mode === "wide"
          ? query.or(`title.ilike.*${q}*,teacher_name.ilike.*${q}*,institution.ilike.*${q}*`)
          : query.ilike("title", `%${q}%`);
    }
    return sorted(query, sort).range(offset, offset + limit - 1);
  };

  // শিরোনামের পাশাপাশি প্রতিষ্ঠান/শিক্ষকের নামেও খোঁজা। কোনো কারণে সেই কোয়েরি ফেল করলে আগের মতো শুধু শিরোনামে।
  let res = await run(q ? "wide" : "title");
  if (res.error && q) res = await run("title");
  if (res.error) throw res.error;
  return { rows: res.data ?? [], total: res.count ?? res.data?.length ?? 0 };
}

export async function fetchPapers(options = {}) {
  return (await fetchPaperPage(options)).rows;
}

export async function fetchPaperBySlug(slug) {
  const { data, error } = await supabase
    .from(PAPERS_TABLE)
    .select("*")
    .eq("slug", slug)
    .eq("status", "approved")
    .single();
  if (error) throw error;
  return data;
}

export async function fetchRelatedPapers({ slug, tags = [], limit = 4 }) {
  let query = supabase.from(PAPERS_TABLE).select(CARD_FIELDS).eq("status", "approved").neq("slug", slug);
  if (tags.length > 0) query = query.contains("term_values", tags);
  const { data, error } = await query.order("copy_count", { ascending: false }).limit(limit);
  if (error) throw error;
  return data ?? [];
}

// দুইটাই best-effort — count বাড়ানো ব্যর্থ হলেও ভিজিটরের অভিজ্ঞতা যেন আটকে না যায়,
// তাই caller-রা এগুলোর error ধরে থামে না।
export async function bumpView(slug) {
  await supabase.rpc("increment_paper_view", { p_slug: slug }).then(null, () => {});
}

export async function bumpCopy(slug) {
  await supabase.rpc("increment_paper_copy", { p_slug: slug }).then(null, () => {});
}
